import { useState } from "react";
import UpdateCity from "../modal/UpdateCity";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import useCountry from "../../../utils/CustomHooks/useCountry";
// import useCityAPI from "../../../utils/CustomHooks/useCityAPI";
import useRemoveAPI from "../../../utils/CustomHooks/useRemoveAPI";
import { Popconfirm } from 'antd';

export default function ListItem({
  item,
  refresh,
  access = {},
  countryList = [],
}) {
  const [isEdit, setEdit] = useState(false);
  const { country, getCountry } = useCountry();
  const {removeCity} = useRemoveAPI();
    const onDelete = () => {
    removeCity({ city_id: item.city_id }, refresh);
  };
  useEffect(() => {
    if (item.country_id) {
      getCountry(item.country_id);
    }
  }, [item]);

  return (
    <tr>
      <td className="col-sm-2">{item.city_name??"-"}</td>
      <td>{country.country_name??"-"}</td>
      <td>{item.city_short_code??"-"}</td>
      {/* <td>{item.time_zone_name}</td>
      <td>{item.time_zone_utc_offset}</td>
      <td>{item.time_zone_short_code}</td> */}
      <td>
        <span
          className={`${item.active ? "good" : "bad"} text-center btn btn-sm`}
        >
          {item.active ? "Active" : "Disabled"}
        </span>
      </td>
      {access.canEdit && (
        <td>
        <button
          type="button"
          className="btn btn-outline-success btn-sm "
          onClick={() => setEdit(true)}
        >
          Edit
        </button>
      </td>
      )}
      <td>
      <Popconfirm
           title="Are you sure to delete this City?"
           onConfirm={onDelete}
          //  onCancel={cancel}
           okText="Yes"
           cancelText="No"
          >
        <i
        className="ml-2 fas fa-trash cursor-pointer"
        // onClick={onDelete}
      ></i>
      </Popconfirm>
      </td>
      <UpdateCity
        isOpen={isEdit}
        setOpen={() => setEdit(false)}
        initialValue={item}
        refresh={refresh}
        countryList={countryList}
        city_id={item.city_id}
      />
    </tr>
  );
}
